import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import { FC } from 'react';
import styled from 'styled-components';

import useStaffDuplicate from './hooks/useStaffDuplicate';
import useNotStableWarning from '../../../../my-projects/MyStreamsSection/hooks/useNotStableWarning';
import Tooltip from '@anm/components/Tooltip';
import { notStableTooltip } from '@anm/components/dropdown-actions/NotStableTooltip';

type StaffDuplicateProps = {
  projectId: string;
  disabled?: boolean;
};

const ButtonWrapper = styled(ButtonLoader)`
  margin-right: 10px;
`;

const StaffDuplicate: FC<StaffDuplicateProps> = ({ projectId, disabled = false }) => {
  const [isPending, canDuplicate, handleDuplicate] = useStaffDuplicate(projectId);

  const { checkUpload, isNotStable } = useNotStableWarning({
    projectId
  });

  const handleClick = () => checkUpload({ cb: handleDuplicate, showWarning: false });

  if (!canDuplicate) return null;

  return (
    <Tooltip renderContent={isNotStable ? notStableTooltip : undefined}>
      <ButtonWrapper
        size="big"
        color="blue"
        variant="white-blue-border-share"
        onClick={handleClick}
        disabled={disabled || isNotStable}
        {...{ isPending }}
      >
        Duplicate
      </ButtonWrapper>
    </Tooltip>
  );
};

export default StaffDuplicate;
